import React /* useEffect */ from "react"

import LayoutHeaderMenu from "../components/LayoutHeaderMenu/LayoutHeaderMenu"

import "./index.scss"

const LandingPage = (props) => {
  const { set_metadata } = props.pageContext.content.contentNew
  const siteMetadata = {
    title: set_metadata.text_page_title,
    description: set_metadata.text_page_description,
    meta: [
      {
        name: "keywords",
        content: set_metadata.text_keywords,
      },
    ],
    author: `prodHost`,
  }

  return (
    <div className="index-wrapper">
      <LayoutHeaderMenu
        siteMetadata={siteMetadata}
        header_logo={
          props.pageContext.content.global_values.set_logos
            .asset_prodhost_logo_white_120p
        }
        header_title={props.pageContext.content.contentNew.text_header_title}
        header_description={
          props.pageContext.content.contentNew.text_header_description
        }
        background_picture={
          props.pageContext.content.contentNew.text_background_picture
        }
        footerCarousel={props.pageContext.content.contentNew.arr_footer_videos}
        items={props.pageContext.content.contentNew}
        items_videos={props.pageContext.content.apiVideoData}
        menu={props.pageContext.menu.entries}
        footer={props.pageContext.content.global_values.set_footer}
      ></LayoutHeaderMenu>
    </div>
  )
}

export default LandingPage
